import { PaletteMode, SimplePaletteColorOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { successColor } from './status/success';

export const success = (mode: PaletteMode, opts: GetThemeOptions): SimplePaletteColorOptions => {
  const color = successColor(mode, opts);
  return {
    main: color.main,
    light: mode === 'light' ? color.lowContrast : color.highContrast,
    dark: mode === 'light' ? color.highContrast : color.lowContrast,
  };
};
